/**
 * video-to-sound/timeline.js — window.VideoSoundTimeline
 *
 * The strip under the video: a filmstrip of the prepared range, the scene
 * boundaries the preparation found, the part that will be voiced (two handles),
 * a playhead, and — once takes exist — which scenes already have sound.
 *
 * DOM, not canvas: percentages make it crisp and correct at any width and
 * device pixel ratio without a resize loop, and the handles are real sliders
 * (role="slider", arrow keys, Home/End) for keyboard and screen-reader users.
 *
 *   var tl = VideoSoundTimeline.create(host, { onSeek, onSelect, onScene, labels });
 *   tl.set({ duration, thumbs:[{t,url}], scenes:[{start,end,state}], sel:{start,end}, maxSel });
 *   tl.playhead(sec);   tl.destroy();
 */
(function (w) {
    'use strict';
    if (w.VideoSoundTimeline) return;

    function el(tag, cls, attrs) {
        var e = document.createElement(tag);
        if (cls) e.className = cls;
        if (attrs) for (var k in attrs) if (attrs.hasOwnProperty(k)) e.setAttribute(k, attrs[k]);
        return e;
    }
    function clock(s) {
        s = Math.max(0, s || 0);
        var m = Math.floor(s / 60), r = s - m * 60;
        return m + ':' + (r < 10 ? '0' : '') + r.toFixed(1);
    }

    function create(host, opts) {
        opts = opts || {};
        var L = opts.labels || {};
        var st = { duration: 0, thumbs: [], scenes: [], sel: { start: 0, end: 0 }, maxSel: Infinity, head: 0 };

        host.innerHTML = '';
        host.classList.add('vst');
        var track = el('div', 'vst-track');
        var strip = el('div', 'vst-strip', { 'aria-hidden': 'true' });
        var scenesLayer = el('div', 'vst-scenes');
        var shadeL = el('div', 'vst-shade vst-shade-l');
        var shadeR = el('div', 'vst-shade vst-shade-r');
        var selBox = el('div', 'vst-sel');
        var hStart = el('div', 'vst-handle vst-h-start', { role: 'slider', tabindex: '0', 'aria-label': L.start || 'Start' });
        var hEnd = el('div', 'vst-handle vst-h-end', { role: 'slider', tabindex: '0', 'aria-label': L.end || 'End' });
        var head = el('div', 'vst-head', { 'aria-hidden': 'true' });
        track.appendChild(strip); track.appendChild(scenesLayer); track.appendChild(shadeL); track.appendChild(shadeR);
        track.appendChild(selBox); track.appendChild(hStart); track.appendChild(hEnd); track.appendChild(head);
        var ruler = el('div', 'vst-ruler', { 'aria-hidden': 'true' });
        host.appendChild(track); host.appendChild(ruler);

        function pct(t) { return st.duration > 0 ? (100 * t / st.duration) : 0; }
        function tAt(clientX) {
            var r = track.getBoundingClientRect();
            var x = Math.min(Math.max(clientX - r.left, 0), r.width);
            var rtl = getComputedStyle(track).direction === 'rtl';
            var f = r.width > 0 ? x / r.width : 0;
            return (rtl ? 1 - f : f) * st.duration;
        }

        function renderStrip() {
            strip.innerHTML = '';
            if (!st.thumbs.length || !(st.duration > 0)) return;
            var width = track.clientWidth || 600;
            var cells = Math.max(4, Math.min(st.thumbs.length, Math.round(width / 64)));
            for (var i = 0; i < cells; i++) {
                var tc = (i + 0.5) * st.duration / cells, best = st.thumbs[0];
                for (var k = 0; k < st.thumbs.length; k++) if (Math.abs(st.thumbs[k].t - tc) < Math.abs(best.t - tc)) best = st.thumbs[k];
                var c = el('div', 'vst-cell');
                c.style.backgroundImage = 'url("' + best.url + '")';
                strip.appendChild(c);
            }
        }
        function renderScenes() {
            scenesLayer.innerHTML = '';
            st.scenes.forEach(function (s, i) {
                var b = el('button', 'vst-scene vst-' + (s.state || 'none'), {
                    type: 'button',
                    'aria-label': (L.scene || 'Scene :n').replace(':n', i + 1) + ' · ' + clock(s.start) + '–' + clock(s.end)
                });
                b.style.insetInlineStart = pct(s.start) + '%';
                b.style.width = (pct(s.end) - pct(s.start)) + '%';
                var tag = el('span', 'vst-scene-n');
                tag.textContent = String(i + 1);
                b.appendChild(tag);
                b.addEventListener('click', function (e) { e.stopPropagation(); if (opts.onScene) opts.onScene(i); });
                scenesLayer.appendChild(b);
            });
        }
        function renderSel() {
            var a = pct(st.sel.start), b = pct(st.sel.end);
            shadeL.style.insetInlineStart = '0%'; shadeL.style.width = a + '%';
            shadeR.style.insetInlineStart = b + '%'; shadeR.style.width = (100 - b) + '%';
            selBox.style.insetInlineStart = a + '%'; selBox.style.width = (b - a) + '%';
            hStart.style.insetInlineStart = a + '%'; hEnd.style.insetInlineStart = b + '%';
            [[hStart, st.sel.start], [hEnd, st.sel.end]].forEach(function (p) {
                p[0].setAttribute('aria-valuemin', '0');
                p[0].setAttribute('aria-valuemax', String(Math.round(st.duration * 10) / 10));
                p[0].setAttribute('aria-valuenow', String(Math.round(p[1] * 10) / 10));
                p[0].setAttribute('aria-valuetext', clock(p[1]));
            });
            var whole = st.sel.start <= 0.01 && st.sel.end >= st.duration - 0.01;
            host.classList.toggle('vst-whole', whole);
        }
        function renderRuler() {
            ruler.innerHTML = '';
            if (!(st.duration > 0)) return;
            var marks = st.duration <= 12 ? 4 : st.duration <= 60 ? 6 : 8;
            for (var i = 0; i <= marks; i++) {
                var t = st.duration * i / marks, m = el('span', 'vst-mark');
                m.style.insetInlineStart = pct(t) + '%';
                m.textContent = clock(t).replace(/\.\d$/, '');
                ruler.appendChild(m);
            }
        }
        function render() { renderStrip(); renderScenes(); renderSel(); renderRuler(); head.style.insetInlineStart = pct(st.head) + '%'; }

        function clampSel(which, t) {
            t = Math.max(0, Math.min(st.duration, t));
            var a = st.sel.start, b = st.sel.end, min = 1;
            if (which === 'start') { a = Math.min(t, b - min); if (b - a > st.maxSel) a = b - st.maxSel; }
            else { b = Math.max(t, a + min); if (b - a > st.maxSel) b = a + st.maxSel; }
            st.sel = { start: Math.max(0, a), end: Math.min(st.duration, b) };
            renderSel();
            if (opts.onSelect) opts.onSelect({ start: st.sel.start, end: st.sel.end, live: true });
        }

        function drag(which) {
            return function (e) {
                e.preventDefault(); e.stopPropagation();
                var tgt = e.currentTarget;
                try { tgt.setPointerCapture(e.pointerId); } catch (_) {}
                tgt.classList.add('is-drag');
                var move = function (ev) { clampSel(which, tAt(ev.clientX)); };
                var up = function () {
                    tgt.classList.remove('is-drag');
                    tgt.removeEventListener('pointermove', move); tgt.removeEventListener('pointerup', up); tgt.removeEventListener('pointercancel', up);
                    if (opts.onSelect) opts.onSelect({ start: st.sel.start, end: st.sel.end, live: false });
                };
                tgt.addEventListener('pointermove', move); tgt.addEventListener('pointerup', up); tgt.addEventListener('pointercancel', up);
            };
        }
        function keys(which) {
            return function (e) {
                var step = e.shiftKey ? 1 : 0.1, cur = which === 'start' ? st.sel.start : st.sel.end, t = null;
                if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') t = cur - step;
                else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') t = cur + step;
                else if (e.key === 'Home') t = 0;
                else if (e.key === 'End') t = st.duration;
                if (t === null) return;
                e.preventDefault();
                clampSel(which, t);
                if (opts.onSelect) opts.onSelect({ start: st.sel.start, end: st.sel.end, live: false });
            };
        }
        hStart.addEventListener('pointerdown', drag('start'));
        hEnd.addEventListener('pointerdown', drag('end'));
        hStart.addEventListener('keydown', keys('start'));
        hEnd.addEventListener('keydown', keys('end'));

        // Click / drag on the strip seeks.
        track.addEventListener('pointerdown', function (e) {
            if (e.target === hStart || e.target === hEnd) return;
            var seek = function (ev) { var t = tAt(ev.clientX); st.head = t; head.style.insetInlineStart = pct(t) + '%'; if (opts.onSeek) opts.onSeek(t); };
            seek(e);
            try { track.setPointerCapture(e.pointerId); } catch (_) {}
            var up = function () { track.removeEventListener('pointermove', seek); track.removeEventListener('pointerup', up); track.removeEventListener('pointercancel', up); };
            track.addEventListener('pointermove', seek); track.addEventListener('pointerup', up); track.addEventListener('pointercancel', up);
        });

        var ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(function () { renderStrip(); }) : null;
        if (ro) ro.observe(track);

        return {
            set: function (p) {
                if (p.duration != null) st.duration = p.duration;
                if (p.thumbs) st.thumbs = p.thumbs;
                if (p.scenes) st.scenes = p.scenes;
                if (p.sel) st.sel = { start: p.sel.start, end: p.sel.end };
                if (p.maxSel != null) st.maxSel = p.maxSel;
                render();
            },
            playhead: function (t) { st.head = t; head.style.insetInlineStart = pct(t) + '%'; },
            sel: function () { return { start: st.sel.start, end: st.sel.end }; },
            destroy: function () { if (ro) ro.disconnect(); host.innerHTML = ''; }
        };
    }

    w.VideoSoundTimeline = { create: create, clock: clock };
})(window);
